// Certificates share the saved white-card document fields; SOT identifies the certificate.
export const isWhiteCardCertificate = number => /^SOT/i.test(String(number || '').trim());
export const certificateNumberSuffix = (number, prefix = 'SOT') => String(number || '').replace(new RegExp('^' + prefix, 'i'), '');
export const toCertificateNumber = (suffix, prefix = 'SOT') => prefix + certificateNumberSuffix(suffix, prefix).replace(/[^0-9]/g, '');
export function certificateExpiryDate(value, days = 60) {
  if (!value) return '';
  const date = /^\d{4}-\d{2}-\d{2}$/.test(String(value)) ? new Date(...String(value).split('-').map((part, index) => Number(part) - (index === 1 ? 1 : 0))) : new Date(value);
  if (!Number.isFinite(date.getTime())) return '';
  date.setDate(date.getDate() + days);
  return date;
}

export const isTrafficCertificate = number => /^SOC/i.test(String(number || '').trim());
